
<template>
	<div class="news_listing">
		<div class="inner">
			<ul class="filter" v-if="show_filter === 'on'">
				<h2 v-if="show_title === 'on'">Outputs</h2>
				<h2 class="dash">&mdash;</h2>
				<h2>
					<a
						v-on:click="currentFilter = 'all'"
						:class="{ current: currentFilter == 'all' }"
						>All</a
					>
				</h2>
				<h2 v-for="(category, index) in JSON.parse(categories)" :key="index">
					<a
						:id="category.id"
						v-on:click="currentFilter = category.name"
						:class="{ current: category.name == currentFilter }"
						v-html="category.name"></a
					>
				</h2>
			</ul>

			<h4 v-if="paginatedData.length == 0">
				We apologise, no posts match your criteria.
			</h4>

			<news-listing-item
				v-for="(post, index) in paginatedData"
				:key="index"
				:title="post.title"
				:permalink="post.permalink"
				:background="post.background_image"
				:category="post.category"
				:size="post.size"
			>
			</news-listing-item>

			<div
				class="posts-navigation"
				v-if="pageCount != 1 && show_pagination === 'on'"
			>
				<h2
					class="prev-next previous"
					v-if="pageNumber != 0"
					@click="pageNumber--"
				>
					&larr; Previous
				</h2>

				<a
					class="page-numbers"
					:class="{ current: index == pageNumber }"
					v-for="(post, index) in pageCount"
					:key="index"
					@click="pageNumber = index"
				>
					<h2 v-html="index + 1"></h2>
				</a>

				<h2
					class="prev-next next"
					v-if="pageNumber != pageCount - 1"
					@click="pageNumber++"
				>
					Next &rarr;
				</h2>
			</div>
		</div>
	</div>
</template>

<script>
import NewsListingItem from '../vue/NewsListingItem.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			show: false,
			currentFilter: 'all',
			visible: true,
			pageNumber: 0, // default to page 0
			paginatedStuff: this.pagination(),
			number_of_posts: this.number_posts_per_page(),
		};
	},

	props: {
		size: {
			default: 'one',
		},
		posts: {},
		categories: {},
		show_title: {},
		show_filter: {},
		show_pagination: {},
		data_size: {
			type: Number,
			required: false,
			default: 10,
		},
		posts_per_page: {
			required: true,
		},
	},

	computed: {
		pageCount() {
			let l = this.filteredCategory.length,
				s = this.number_of_posts;
			return Math.ceil(l / s);
		},

		paginatedData() {
			const start = this.pageNumber * this.number_of_posts,
				end = start + this.number_of_posts;
			return this.filteredCategory.slice(start, end);
		},

		filteredCategory() {
			var vm = this;
			var category = vm.currentFilter;

			if (category === 'all') {
				return vm.paginatedStuff;
			} else {
				return vm.paginatedStuff.filter(function (article) {
					const catCheck = (element) => element['name'] === category;
					return article.category.some(catCheck);
				});
			}
		},
	},

	watch: {
    currentFilter() {
      this.pageNumber = 0;
    },
  },

	methods: {
		nextPage() {
			this.pageNumber++;
		},
		prevPage() {
			this.pageNumber--;
		},

		pagination() {
			let parsed = JSON.parse(this.posts);
			return parsed;
		},

		number_posts_per_page() {
			let the_result = JSON.parse(this.posts_per_page);
			return the_result.number;
		},
	},

	components: {
		NewsListingItem,
	},

	created() {
		this.currentFilter = 'all';
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.news_listing {
	display: grid;
	grid-template-columns: repeat(18, 1fr);
	// margin-bottom: 4rem;
	padding: 0;
	grid-column: 1 / span 8;

	@media (max-width: $md) {
		grid-template-columns: repeat(12, 1fr);
	}

	.inner {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-column: 1 / span 18;
		column-gap: 2rem;
		row-gap: 2rem;

		@media (max-width: $md) {
			grid-template-columns: repeat(10, 1fr);
			grid-column: 1 / span 12;
			column-gap: 0;
		}

		> h2 {
			grid-column: span 3;
			font-size: 2rem;
			margin: 0 0 2rem;
			text-align: center;
			color: #ddd;

			@media (max-width: $md) {
				grid-column: span 10;
				font-size: 1.25rem;
			}

			span {
				font-family: 'GT Sectra', Arial, Helvetica, sans-serif;
				color: $edc-red;
				font-style: normal;
				font-weight: bold;
			}
		}

		.filter {
			grid-column: span 3;
      display: flex;
      flex-wrap: wrap;
			flex-direction: row;
			list-style: none;
			margin: 0;
			padding: 0;

			@media (max-width: $md) {
				grid-column: span 10;
				flex-wrap: wrap;
				// row-gap: 1rem;
			}

			h2 {
				margin-right: 0.5rem;
				font-weight: bold;

				a {
					text-decoration: none;
					font-weight: bold;

					&:hover {
						cursor: pointer;
					}

					&.current {
						color: $edc-red;
					}
				}
			}
		}

		.posts-navigation {
			grid-column: 1 / span 3;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-top: 0;

			@media (max-width: $md) {
				grid-column: span 10;
				flex-wrap: wrap;
				row-gap: 1rem;
			}

			.prev-next {
				&:hover {
          cursor: pointer;
          color: $edc-red;
				}

				&.previous {
					margin: 0 1rem 0 0;
				}
			}

			.page-numbers {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0;
				margin: 0 1rem 0 0;
				text-decoration: none;
				color: black;
				transition: 0.2s all ease;
				font-weight: bold;

				// @media (max-width: $md) {
				// 	padding: 1rem 1.5rem;
				// }

				&:hover {
					color: $edc-red;
					cursor: pointer;
				}

				&.current {
					color: $edc-red;
				}
			}
		}

		.news_listing__item {
			&.not_visible {
				display: none;
			}

			&.visible {
				display: flex;
			}
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/NewsListing.vue